export default __webpack_public_path__ + "static/media/edge_logo_white.svg";